// ----------------------------------------------------------------------------
// Snippet: Card Label
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_card-label.scss';